import * as M from "react";
import be, { version as so, isValidElement as co, useContext as ut, useRef as ye, useLayoutEffect as uo, useEffect as nt } from "react";
import { _ as an } from "./extends.js";
import { g as lo } from "./_commonjsHelpers.js";
import xr from "react-dom";
var sn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var c = arguments[a];
        c && (i = o(i, n(c)));
      }
      return i;
    }
    function n(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var c in i)
        t.call(i, c) && i[c] && (a = o(a, c));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(sn);
var fo = sn.exports;
const vo = /* @__PURE__ */ lo(fo);
function $(e) {
  "@babel/helpers - typeof";
  return $ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $(e);
}
var ho = Symbol.for("react.element"), po = Symbol.for("react.transitional.element"), go = Symbol.for("react.fragment");
function mo(e) {
  return (
    // Base object type
    e && $(e) === "object" && // React Element type
    (e.$$typeof === ho || e.$$typeof === po) && // React Fragment type
    e.type === go
  );
}
var Lt = {}, dr = [], yo = function(t) {
  dr.push(t);
};
function vr(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = dr.reduce(function(n, o) {
      return o(n ?? "", "warning");
    }, t);
    r && console.error("Warning: ".concat(r));
  }
}
function bo(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var r = dr.reduce(function(n, o) {
      return o(n ?? "", "note");
    }, t);
    r && console.warn("Note: ".concat(r));
  }
}
function So() {
  Lt = {};
}
function cn(e, t, r) {
  !t && !Lt[r] && (e(!1, r), Lt[r] = !0);
}
function Xe(e, t) {
  cn(vr, e, t);
}
function Eo(e, t) {
  cn(bo, e, t);
}
Xe.preMessage = yo;
Xe.resetWarned = So;
Xe.noteOnce = Eo;
function xo(e, t) {
  if ($(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if ($(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function un(e) {
  var t = xo(e, "string");
  return $(t) == "symbol" ? t : t + "";
}
function A(e, t, r) {
  return (t = un(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Cr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function k(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cr(Object(r), !0).forEach(function(n) {
      A(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Cr(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Tr(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function Co(e) {
  return e && $(e) === "object" && Tr(e.nativeElement) ? e.nativeElement : Tr(e) ? e : null;
}
function To(e) {
  var t = Co(e);
  if (t)
    return t;
  if (e instanceof be.Component) {
    var r;
    return (r = xr.findDOMNode) === null || r === void 0 ? void 0 : r.call(xr, e);
  }
  return null;
}
var It = { exports: {} }, j = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _r;
function _o() {
  if (_r) return j;
  _r = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y;
  y = Symbol.for("react.module.reference");
  function h(v) {
    if (typeof v == "object" && v !== null) {
      var S = v.$$typeof;
      switch (S) {
        case e:
          switch (v = v.type, v) {
            case r:
            case o:
            case n:
            case u:
            case l:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case c:
                case a:
                case s:
                case f:
                case d:
                case i:
                  return v;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  return j.ContextConsumer = a, j.ContextProvider = i, j.Element = e, j.ForwardRef = s, j.Fragment = r, j.Lazy = f, j.Memo = d, j.Portal = t, j.Profiler = o, j.StrictMode = n, j.Suspense = u, j.SuspenseList = l, j.isAsyncMode = function() {
    return !1;
  }, j.isConcurrentMode = function() {
    return !1;
  }, j.isContextConsumer = function(v) {
    return h(v) === a;
  }, j.isContextProvider = function(v) {
    return h(v) === i;
  }, j.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, j.isForwardRef = function(v) {
    return h(v) === s;
  }, j.isFragment = function(v) {
    return h(v) === r;
  }, j.isLazy = function(v) {
    return h(v) === f;
  }, j.isMemo = function(v) {
    return h(v) === d;
  }, j.isPortal = function(v) {
    return h(v) === t;
  }, j.isProfiler = function(v) {
    return h(v) === o;
  }, j.isStrictMode = function(v) {
    return h(v) === n;
  }, j.isSuspense = function(v) {
    return h(v) === u;
  }, j.isSuspenseList = function(v) {
    return h(v) === l;
  }, j.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === r || v === o || v === n || v === u || v === l || v === p || typeof v == "object" && v !== null && (v.$$typeof === f || v.$$typeof === d || v.$$typeof === i || v.$$typeof === a || v.$$typeof === s || v.$$typeof === y || v.getModuleId !== void 0);
  }, j.typeOf = h, j;
}
var D = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Ao() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y = !1, h = !1, v = !1, S = !1, b = !1, T;
    T = Symbol.for("react.module.reference");
    function x(_) {
      return !!(typeof _ == "string" || typeof _ == "function" || _ === r || _ === o || b || _ === n || _ === u || _ === l || S || _ === p || y || h || v || typeof _ == "object" && _ !== null && (_.$$typeof === f || _.$$typeof === d || _.$$typeof === i || _.$$typeof === a || _.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      _.$$typeof === T || _.getModuleId !== void 0));
    }
    function g(_) {
      if (typeof _ == "object" && _ !== null) {
        var De = _.$$typeof;
        switch (De) {
          case e:
            var ee = _.type;
            switch (ee) {
              case r:
              case o:
              case n:
              case u:
              case l:
                return ee;
              default:
                var Ue = ee && ee.$$typeof;
                switch (Ue) {
                  case c:
                  case a:
                  case s:
                  case f:
                  case d:
                  case i:
                    return Ue;
                  default:
                    return De;
                }
            }
          case t:
            return De;
        }
      }
    }
    var E = a, m = i, C = e, I = s, L = r, B = f, H = d, P = t, w = o, O = n, z = u, G = l, V = !1, K = !1;
    function X(_) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function W(_) {
      return K || (K = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(_) {
      return g(_) === a;
    }
    function F(_) {
      return g(_) === i;
    }
    function Q(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === e;
    }
    function ue(_) {
      return g(_) === s;
    }
    function Ce(_) {
      return g(_) === r;
    }
    function ne(_) {
      return g(_) === f;
    }
    function je(_) {
      return g(_) === d;
    }
    function Te(_) {
      return g(_) === t;
    }
    function _e(_) {
      return g(_) === o;
    }
    function Ae(_) {
      return g(_) === n;
    }
    function le(_) {
      return g(_) === u;
    }
    function ke(_) {
      return g(_) === l;
    }
    D.ContextConsumer = E, D.ContextProvider = m, D.Element = C, D.ForwardRef = I, D.Fragment = L, D.Lazy = B, D.Memo = H, D.Portal = P, D.Profiler = w, D.StrictMode = O, D.Suspense = z, D.SuspenseList = G, D.isAsyncMode = X, D.isConcurrentMode = W, D.isContextConsumer = N, D.isContextProvider = F, D.isElement = Q, D.isForwardRef = ue, D.isFragment = Ce, D.isLazy = ne, D.isMemo = je, D.isPortal = Te, D.isProfiler = _e, D.isStrictMode = Ae, D.isSuspense = le, D.isSuspenseList = ke, D.isValidElementType = x, D.typeOf = g;
  }()), D;
}
process.env.NODE_ENV === "production" ? It.exports = _o() : It.exports = Ao();
var Ct = It.exports;
function ko(e, t, r) {
  var n = M.useRef({});
  return (!("value" in n.current) || r(n.current.condition, t)) && (n.current.value = e(), n.current.condition = t), n.current.value;
}
var Mo = Number(so.split(".")[0]), ln = function(t, r) {
  typeof t == "function" ? t(r) : $(t) === "object" && t && "current" in t && (t.current = r);
}, wo = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var o = r.filter(Boolean);
  return o.length <= 1 ? o[0] : function(i) {
    r.forEach(function(a) {
      ln(a, i);
    });
  };
}, ss = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return ko(function() {
    return wo.apply(void 0, r);
  }, r, function(o, i) {
    return o.length !== i.length || o.every(function(a, c) {
      return a !== i[c];
    });
  });
}, fn = function(t) {
  var r, n;
  if (!t)
    return !1;
  if (hr(t) && Mo >= 19)
    return !0;
  var o = Ct.isMemo(t) ? t.type.type : t.type;
  return !(typeof o == "function" && !((r = o.prototype) !== null && r !== void 0 && r.render) && o.$$typeof !== Ct.ForwardRef || typeof t == "function" && !((n = t.prototype) !== null && n !== void 0 && n.render) && t.$$typeof !== Ct.ForwardRef);
};
function hr(e) {
  return /* @__PURE__ */ co(e) && !mo(e);
}
var cs = function(t) {
  return hr(t) && fn(t);
}, Ro = function(t) {
  if (t && hr(t)) {
    var r = t;
    return r.props.propertyIsEnumerable("ref") ? r.props.ref : r.ref;
  }
  return null;
};
function fe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function kr(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, un(n.key), n);
  }
}
function de(e, t, r) {
  return t && kr(e.prototype, t), r && kr(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ht(e, t) {
  return Ht = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Ht(e, t);
}
function ht(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ht(e, t);
}
function lt(e) {
  return lt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, lt(e);
}
function dn() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (dn = function() {
    return !!e;
  })();
}
function Se(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Po(e, t) {
  if (t && ($(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Se(e);
}
function pt(e) {
  var t = dn();
  return function() {
    var r, n = lt(e);
    if (t) {
      var o = lt(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else r = n.apply(this, arguments);
    return Po(this, r);
  };
}
function jt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Oo(e) {
  if (Array.isArray(e)) return jt(e);
}
function Lo(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function vn(e, t) {
  if (e) {
    if (typeof e == "string") return jt(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? jt(e, t) : void 0;
  }
}
function Io() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xe(e) {
  return Oo(e) || Lo(e) || vn(e) || Io();
}
var hn = function(t) {
  return +setTimeout(t, 16);
}, pn = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (hn = function(t) {
  return window.requestAnimationFrame(t);
}, pn = function(t) {
  return window.cancelAnimationFrame(t);
});
var Mr = 0, gt = /* @__PURE__ */ new Map();
function gn(e) {
  gt.delete(e);
}
var ft = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Mr += 1;
  var n = Mr;
  function o(i) {
    if (i === 0)
      gn(n), t();
    else {
      var a = hn(function() {
        o(i - 1);
      });
      gt.set(n, a);
    }
  }
  return o(r), n;
};
ft.cancel = function(e) {
  var t = gt.get(e);
  return gn(e), pn(t);
};
process.env.NODE_ENV !== "production" && (ft.ids = function() {
  return gt;
});
function Ho(e) {
  if (Array.isArray(e)) return e;
}
function jo(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, o, i, a, c = [], s = !0, u = !1;
    try {
      if (i = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        s = !1;
      } else for (; !(s = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); s = !0) ;
    } catch (l) {
      u = !0, o = l;
    } finally {
      try {
        if (!s && r.return != null && (a = r.return(), Object(a) !== a)) return;
      } finally {
        if (u) throw o;
      }
    }
    return c;
  }
}
function Do() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function R(e, t) {
  return Ho(e) || jo(e, t) || vn(e, t) || Do();
}
function Ve(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function ge() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Bo(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var wr = "data-rc-order", Rr = "data-rc-priority", zo = "rc-util-key", Dt = /* @__PURE__ */ new Map();
function mn() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : zo;
}
function mt(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function Fo(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function pr(e) {
  return Array.from((Dt.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function yn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!ge())
    return null;
  var r = t.csp, n = t.prepend, o = t.priority, i = o === void 0 ? 0 : o, a = Fo(n), c = a === "prependQueue", s = document.createElement("style");
  s.setAttribute(wr, a), c && i && s.setAttribute(Rr, "".concat(i)), r != null && r.nonce && (s.nonce = r == null ? void 0 : r.nonce), s.innerHTML = e;
  var u = mt(t), l = u.firstChild;
  if (n) {
    if (c) {
      var d = (t.styles || pr(u)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(wr)))
          return !1;
        var p = Number(f.getAttribute(Rr) || 0);
        return i >= p;
      });
      if (d.length)
        return u.insertBefore(s, d[d.length - 1].nextSibling), s;
    }
    u.insertBefore(s, l);
  } else
    u.appendChild(s);
  return s;
}
function bn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = mt(t);
  return (t.styles || pr(r)).find(function(n) {
    return n.getAttribute(mn(t)) === e;
  });
}
function Sn(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = bn(e, t);
  if (r) {
    var n = mt(t);
    n.removeChild(r);
  }
}
function No(e, t) {
  var r = Dt.get(e);
  if (!r || !Bo(document, r)) {
    var n = yn("", t), o = n.parentNode;
    Dt.set(e, o), e.removeChild(n);
  }
}
function Ne(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = mt(r), o = pr(n), i = k(k({}, r), {}, {
    styles: o
  });
  No(n, i);
  var a = bn(t, i);
  if (a) {
    var c, s;
    if ((c = i.csp) !== null && c !== void 0 && c.nonce && a.nonce !== ((s = i.csp) === null || s === void 0 ? void 0 : s.nonce)) {
      var u;
      a.nonce = (u = i.csp) === null || u === void 0 ? void 0 : u.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var l = yn(e, i);
  return l.setAttribute(mn(i), t), l;
}
function $o(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Bt(e, t) {
  if (e == null) return {};
  var r, n, o = $o(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
var Vo = "%";
function zt(e) {
  return e.join(Vo);
}
var Wo = /* @__PURE__ */ function() {
  function e(t) {
    fe(this, e), A(this, "instanceId", void 0), A(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return de(e, [{
    key: "get",
    value: function(r) {
      return this.opGet(zt(r));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(r) {
      return this.cache.get(r) || null;
    }
  }, {
    key: "update",
    value: function(r, n) {
      return this.opUpdate(zt(r), n);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(r, n) {
      var o = this.cache.get(r), i = n(o);
      i === null ? this.cache.delete(r) : this.cache.set(r, i);
    }
  }]), e;
}(), Oe = "data-token-hash", ie = "data-css-hash", Xo = "data-cache-path", he = "__cssinjs_instance__";
function Uo() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(ie, "]")) || [], r = document.head.firstChild;
    Array.from(t).forEach(function(o) {
      o[he] = o[he] || e, o[he] === e && document.head.insertBefore(o, r);
    });
    var n = {};
    Array.from(document.querySelectorAll("style[".concat(ie, "]"))).forEach(function(o) {
      var i = o.getAttribute(ie);
      if (n[i]) {
        if (o[he] === e) {
          var a;
          (a = o.parentNode) === null || a === void 0 || a.removeChild(o);
        }
      } else
        n[i] = !0;
    });
  }
  return new Wo(e);
}
var yt = /* @__PURE__ */ M.createContext({
  hashPriority: "low",
  cache: Uo(),
  defaultCache: !0
});
function Go(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var gr = /* @__PURE__ */ function() {
  function e() {
    fe(this, e), A(this, "cache", void 0), A(this, "keys", void 0), A(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return de(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(r) {
      var n, o, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = {
        map: this.cache
      };
      return r.forEach(function(c) {
        if (!a)
          a = void 0;
        else {
          var s;
          a = (s = a) === null || s === void 0 || (s = s.map) === null || s === void 0 ? void 0 : s.get(c);
        }
      }), (n = a) !== null && n !== void 0 && n.value && i && (a.value[1] = this.cacheCallTimes++), (o = a) === null || o === void 0 ? void 0 : o.value;
    }
  }, {
    key: "get",
    value: function(r) {
      var n;
      return (n = this.internalGet(r, !0)) === null || n === void 0 ? void 0 : n[0];
    }
  }, {
    key: "has",
    value: function(r) {
      return !!this.internalGet(r);
    }
  }, {
    key: "set",
    value: function(r, n) {
      var o = this;
      if (!this.has(r)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var i = this.keys.reduce(function(u, l) {
            var d = R(u, 2), f = d[1];
            return o.internalGet(l)[1] < f ? [l, o.internalGet(l)[1]] : u;
          }, [this.keys[0], this.cacheCallTimes]), a = R(i, 1), c = a[0];
          this.delete(c);
        }
        this.keys.push(r);
      }
      var s = this.cache;
      r.forEach(function(u, l) {
        if (l === r.length - 1)
          s.set(u, {
            value: [n, o.cacheCallTimes++]
          });
        else {
          var d = s.get(u);
          d ? d.map || (d.map = /* @__PURE__ */ new Map()) : s.set(u, {
            map: /* @__PURE__ */ new Map()
          }), s = s.get(u).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(r, n) {
      var o = r.get(n[0]);
      if (n.length === 1) {
        var i;
        return o.map ? r.set(n[0], {
          map: o.map
        }) : r.delete(n[0]), (i = o.value) === null || i === void 0 ? void 0 : i[0];
      }
      var a = this.deleteByPath(o.map, n.slice(1));
      return (!o.map || o.map.size === 0) && !o.value && r.delete(n[0]), a;
    }
  }, {
    key: "delete",
    value: function(r) {
      if (this.has(r))
        return this.keys = this.keys.filter(function(n) {
          return !Go(n, r);
        }), this.deleteByPath(this.cache, r);
    }
  }]), e;
}();
A(gr, "MAX_CACHE_SIZE", 20);
A(gr, "MAX_CACHE_OFFSET", 5);
var Pr = 0, En = /* @__PURE__ */ function() {
  function e(t) {
    fe(this, e), A(this, "derivatives", void 0), A(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = Pr, t.length === 0 && vr(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), Pr += 1;
  }
  return de(e, [{
    key: "getDerivativeToken",
    value: function(r) {
      return this.derivatives.reduce(function(n, o) {
        return o(r, n);
      }, void 0);
    }
  }]), e;
}(), Tt = new gr();
function Ko(e) {
  var t = Array.isArray(e) ? e : [e];
  return Tt.has(t) || Tt.set(t, new En(t)), Tt.get(t);
}
var Yo = /* @__PURE__ */ new WeakMap(), _t = {};
function qo(e, t) {
  for (var r = Yo, n = 0; n < t.length; n += 1) {
    var o = t[n];
    r.has(o) || r.set(o, /* @__PURE__ */ new WeakMap()), r = r.get(o);
  }
  return r.has(_t) || r.set(_t, e()), r.get(_t);
}
var Or = /* @__PURE__ */ new WeakMap();
function $e(e) {
  var t = Or.get(e) || "";
  return t || (Object.keys(e).forEach(function(r) {
    var n = e[r];
    t += r, n instanceof En ? t += n.id : n && $(n) === "object" ? t += $e(n) : t += n;
  }), t = Ve(t), Or.set(e, t)), t;
}
function Lr(e, t) {
  return Ve("".concat(t, "_").concat($e(e)));
}
var Ft = ge();
function Nt(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function dt(e, t, r) {
  var n, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var a = k(k({}, o), {}, (n = {}, A(n, Oe, t), A(n, ie, r), n)), c = Object.keys(a).map(function(s) {
    var u = a[s];
    return u ? "".concat(s, '="').concat(u, '"') : null;
  }).filter(function(s) {
    return s;
  }).join(" ");
  return "<style ".concat(c, ">").concat(e, "</style>");
}
var ot = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(r ? "".concat(r, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, Qo = function(t, r, n) {
  return Object.keys(t).length ? ".".concat(r).concat(n != null && n.scope ? ".".concat(n.scope) : "", "{").concat(Object.entries(t).map(function(o) {
    var i = R(o, 2), a = i[0], c = i[1];
    return "".concat(a, ":").concat(c, ";");
  }).join(""), "}") : "";
}, xn = function(t, r, n) {
  var o = {}, i = {};
  return Object.entries(t).forEach(function(a) {
    var c, s, u = R(a, 2), l = u[0], d = u[1];
    if (n != null && (c = n.preserve) !== null && c !== void 0 && c[l])
      i[l] = d;
    else if ((typeof d == "string" || typeof d == "number") && !(n != null && (s = n.ignore) !== null && s !== void 0 && s[l])) {
      var f, p = ot(l, n == null ? void 0 : n.prefix);
      o[p] = typeof d == "number" && !(n != null && (f = n.unitless) !== null && f !== void 0 && f[l]) ? "".concat(d, "px") : String(d), i[l] = "var(".concat(p, ")");
    }
  }), [i, Qo(o, r, {
    scope: n == null ? void 0 : n.scope
  })];
}, Ir = process.env.NODE_ENV !== "test" && ge() ? M.useLayoutEffect : M.useEffect, Cn = function(t, r) {
  var n = M.useRef(!0);
  Ir(function() {
    return t(n.current);
  }, r), Ir(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, us = function(t, r) {
  Cn(function(n) {
    if (!n)
      return t();
  }, r);
}, Zo = k({}, M), Hr = Zo.useInsertionEffect, Jo = function(t, r, n) {
  M.useMemo(t, n), Cn(function() {
    return r(!0);
  }, n);
}, ei = Hr ? function(e, t, r) {
  return Hr(function() {
    return e(), t();
  }, r);
} : Jo, ti = k({}, M), ri = ti.useInsertionEffect, ni = function(t) {
  var r = [], n = !1;
  function o(i) {
    if (n) {
      process.env.NODE_ENV !== "production" && vr(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    r.push(i);
  }
  return M.useEffect(function() {
    return n = !1, function() {
      n = !0, r.length && r.forEach(function(i) {
        return i();
      });
    };
  }, t), o;
}, oi = function() {
  return function(t) {
    t();
  };
}, ii = typeof ri < "u" ? ni : oi;
function ai() {
  return !1;
}
var $t = !1;
function si() {
  return $t;
}
const ci = process.env.NODE_ENV === "production" ? ai : si;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var Ye = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : null;
  if (Ye && typeof Ye.webpackHotUpdate == "function") {
    var ui = Ye.webpackHotUpdate;
    Ye.webpackHotUpdate = function() {
      return $t = !0, setTimeout(function() {
        $t = !1;
      }, 0), ui.apply(void 0, arguments);
    };
  }
}
function mr(e, t, r, n, o) {
  var i = M.useContext(yt), a = i.cache, c = [e].concat(xe(t)), s = zt(c), u = ii([s]), l = ci(), d = function(h) {
    a.opUpdate(s, function(v) {
      var S = v || [void 0, void 0], b = R(S, 2), T = b[0], x = T === void 0 ? 0 : T, g = b[1], E = g;
      process.env.NODE_ENV !== "production" && g && l && (n == null || n(E, l), E = null);
      var m = E || r(), C = [x, m];
      return h ? h(C) : C;
    });
  };
  M.useMemo(
    function() {
      d();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [s]
    /* eslint-enable */
  );
  var f = a.opGet(s);
  process.env.NODE_ENV !== "production" && !f && (d(), f = a.opGet(s));
  var p = f[1];
  return ei(function() {
    o == null || o(p);
  }, function(y) {
    return d(function(h) {
      var v = R(h, 2), S = v[0], b = v[1];
      return y && S === 0 && (o == null || o(p)), [S + 1, b];
    }), function() {
      a.opUpdate(s, function(h) {
        var v = h || [], S = R(v, 2), b = S[0], T = b === void 0 ? 0 : b, x = S[1], g = T - 1;
        return g === 0 ? (u(function() {
          (y || !a.opGet(s)) && (n == null || n(x, !1));
        }), null) : [T - 1, x];
      });
    };
  }, [s]), p;
}
var li = {}, fi = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", me = /* @__PURE__ */ new Map();
function di(e) {
  me.set(e, (me.get(e) || 0) + 1);
}
function vi(e, t) {
  if (typeof document < "u") {
    var r = document.querySelectorAll("style[".concat(Oe, '="').concat(e, '"]'));
    r.forEach(function(n) {
      if (n[he] === t) {
        var o;
        (o = n.parentNode) === null || o === void 0 || o.removeChild(n);
      }
    });
  }
}
var hi = 0;
function pi(e, t) {
  me.set(e, (me.get(e) || 0) - 1);
  var r = Array.from(me.keys()), n = r.filter(function(o) {
    var i = me.get(o) || 0;
    return i <= 0;
  });
  r.length - n.length > hi && n.forEach(function(o) {
    vi(o, t), me.delete(o);
  });
}
var gi = function(t, r, n, o) {
  var i = n.getDerivativeToken(t), a = k(k({}, i), r);
  return o && (a = o(a)), a;
}, Tn = "token";
function mi(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = ut(yt), o = n.cache.instanceId, i = n.container, a = r.salt, c = a === void 0 ? "" : a, s = r.override, u = s === void 0 ? li : s, l = r.formatToken, d = r.getComputedToken, f = r.cssVar, p = qo(function() {
    return Object.assign.apply(Object, [{}].concat(xe(t)));
  }, t), y = $e(p), h = $e(u), v = f ? $e(f) : "", S = mr(Tn, [c, e.id, y, h, v], function() {
    var b, T = d ? d(p, u, e) : gi(p, u, e, l), x = k({}, T), g = "";
    if (f) {
      var E = xn(T, f.key, {
        prefix: f.prefix,
        ignore: f.ignore,
        unitless: f.unitless,
        preserve: f.preserve
      }), m = R(E, 2);
      T = m[0], g = m[1];
    }
    var C = Lr(T, c);
    T._tokenKey = C, x._tokenKey = Lr(x, c);
    var I = (b = f == null ? void 0 : f.key) !== null && b !== void 0 ? b : C;
    T._themeKey = I, di(I);
    var L = "".concat(fi, "-").concat(Ve(C));
    return T._hashId = L, [T, L, x, g, (f == null ? void 0 : f.key) || ""];
  }, function(b) {
    pi(b[0]._themeKey, o);
  }, function(b) {
    var T = R(b, 4), x = T[0], g = T[3];
    if (f && g) {
      var E = Ne(g, Ve("css-variables-".concat(x._themeKey)), {
        mark: ie,
        prepend: "queue",
        attachTo: i,
        priority: -999
      });
      E[he] = o, E.setAttribute(Oe, x._themeKey);
    }
  });
  return S;
}
var yi = function(t, r, n) {
  var o = R(t, 5), i = o[2], a = o[3], c = o[4], s = n || {}, u = s.plain;
  if (!a)
    return null;
  var l = i._tokenKey, d = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, p = dt(a, c, l, f, u);
  return [d, l, p];
}, bi = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, _n = "comm", An = "rule", kn = "decl", Si = "@import", Ei = "@namespace", xi = "@keyframes", Ci = "@layer", Mn = Math.abs, yr = String.fromCharCode;
function wn(e) {
  return e.trim();
}
function it(e, t, r) {
  return e.replace(t, r);
}
function Ti(e, t, r) {
  return e.indexOf(t, r);
}
function Pe(e, t) {
  return e.charCodeAt(t) | 0;
}
function Le(e, t, r) {
  return e.slice(t, r);
}
function ce(e) {
  return e.length;
}
function _i(e) {
  return e.length;
}
function qe(e, t) {
  return t.push(e), e;
}
var bt = 1, Ie = 1, Rn = 0, re = 0, U = 0, He = "";
function br(e, t, r, n, o, i, a, c) {
  return { value: e, root: t, parent: r, type: n, props: o, children: i, line: bt, column: Ie, length: a, return: "", siblings: c };
}
function Ai() {
  return U;
}
function ki() {
  return U = re > 0 ? Pe(He, --re) : 0, Ie--, U === 10 && (Ie = 1, bt--), U;
}
function ae() {
  return U = re < Rn ? Pe(He, re++) : 0, Ie++, U === 10 && (Ie = 1, bt++), U;
}
function pe() {
  return Pe(He, re);
}
function at() {
  return re;
}
function St(e, t) {
  return Le(He, e, t);
}
function We(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Mi(e) {
  return bt = Ie = 1, Rn = ce(He = e), re = 0, [];
}
function wi(e) {
  return He = "", e;
}
function At(e) {
  return wn(St(re - 1, Vt(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Ri(e) {
  for (; (U = pe()) && U < 33; )
    ae();
  return We(e) > 2 || We(U) > 3 ? "" : " ";
}
function Pi(e, t) {
  for (; --t && ae() && !(U < 48 || U > 102 || U > 57 && U < 65 || U > 70 && U < 97); )
    ;
  return St(e, at() + (t < 6 && pe() == 32 && ae() == 32));
}
function Vt(e) {
  for (; ae(); )
    switch (U) {
      case e:
        return re;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Vt(U);
        break;
      case 40:
        e === 41 && Vt(e);
        break;
      case 92:
        ae();
        break;
    }
  return re;
}
function Oi(e, t) {
  for (; ae() && e + U !== 57; )
    if (e + U === 84 && pe() === 47)
      break;
  return "/*" + St(t, re - 1) + "*" + yr(e === 47 ? e : ae());
}
function Li(e) {
  for (; !We(pe()); )
    ae();
  return St(e, re);
}
function Ii(e) {
  return wi(st("", null, null, null, [""], e = Mi(e), 0, [0], e));
}
function st(e, t, r, n, o, i, a, c, s) {
  for (var u = 0, l = 0, d = a, f = 0, p = 0, y = 0, h = 1, v = 1, S = 1, b = 0, T = "", x = o, g = i, E = n, m = T; v; )
    switch (y = b, b = ae()) {
      case 40:
        if (y != 108 && Pe(m, d - 1) == 58) {
          Ti(m += it(At(b), "&", "&\f"), "&\f", Mn(u ? c[u - 1] : 0)) != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        m += At(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        m += Ri(y);
        break;
      case 92:
        m += Pi(at() - 1, 7);
        continue;
      case 47:
        switch (pe()) {
          case 42:
          case 47:
            qe(Hi(Oi(ae(), at()), t, r, s), s), (We(y || 1) == 5 || We(pe() || 1) == 5) && ce(m) && Le(m, -1, void 0) !== " " && (m += " ");
            break;
          default:
            m += "/";
        }
        break;
      case 123 * h:
        c[u++] = ce(m) * S;
      case 125 * h:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            v = 0;
          case 59 + l:
            S == -1 && (m = it(m, /\f/g, "")), p > 0 && (ce(m) - d || h === 0 && y === 47) && qe(p > 32 ? Dr(m + ";", n, r, d - 1, s) : Dr(it(m, " ", "") + ";", n, r, d - 2, s), s);
            break;
          case 59:
            m += ";";
          default:
            if (qe(E = jr(m, t, r, u, l, o, c, T, x = [], g = [], d, i), i), b === 123)
              if (l === 0)
                st(m, t, E, E, x, i, d, c, g);
              else {
                switch (f) {
                  case 99:
                    if (Pe(m, 3) === 110) break;
                  case 108:
                    if (Pe(m, 2) === 97) break;
                  default:
                    l = 0;
                  case 100:
                  case 109:
                  case 115:
                }
                l ? st(e, E, E, n && qe(jr(e, E, E, 0, 0, o, c, T, o, x = [], d, g), g), o, g, d, c, n ? x : g) : st(m, E, E, E, [""], g, 0, c, g);
              }
        }
        u = l = p = 0, h = S = 1, T = m = "", d = a;
        break;
      case 58:
        d = 1 + ce(m), p = y;
      default:
        if (h < 1) {
          if (b == 123)
            --h;
          else if (b == 125 && h++ == 0 && ki() == 125)
            continue;
        }
        switch (m += yr(b), b * h) {
          case 38:
            S = l > 0 ? 1 : (m += "\f", -1);
            break;
          case 44:
            c[u++] = (ce(m) - 1) * S, S = 1;
            break;
          case 64:
            pe() === 45 && (m += At(ae())), f = pe(), l = d = ce(T = m += Li(at())), b++;
            break;
          case 45:
            y === 45 && ce(m) == 2 && (h = 0);
        }
    }
  return i;
}
function jr(e, t, r, n, o, i, a, c, s, u, l, d) {
  for (var f = o - 1, p = o === 0 ? i : [""], y = _i(p), h = 0, v = 0, S = 0; h < n; ++h)
    for (var b = 0, T = Le(e, f + 1, f = Mn(v = a[h])), x = e; b < y; ++b)
      (x = wn(v > 0 ? p[b] + " " + T : it(T, /&\f/g, p[b]))) && (s[S++] = x);
  return br(e, t, r, o === 0 ? An : c, s, u, l, d);
}
function Hi(e, t, r, n) {
  return br(e, t, r, _n, yr(Ai()), Le(e, 2, -2), 0, n);
}
function Dr(e, t, r, n, o) {
  return br(e, t, r, kn, Le(e, 0, n), Le(e, n + 1, -1), n, o);
}
function Wt(e, t) {
  for (var r = "", n = 0; n < e.length; n++)
    r += t(e[n], n, e, t) || "";
  return r;
}
function ji(e, t, r, n) {
  switch (e.type) {
    case Ci:
      if (e.children.length) break;
    case Si:
    case Ei:
    case kn:
      return e.return = e.return || e.value;
    case _n:
      return "";
    case xi:
      return e.return = e.value + "{" + Wt(e.children, n) + "}";
    case An:
      if (!ce(e.value = e.props.join(","))) return "";
  }
  return ce(r = Wt(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function Pn(e, t) {
  var r = t.path, n = t.parentSelectors;
  Xe(!1, "[Ant Design CSS-in-JS] ".concat(r ? "Error in ".concat(r, ": ") : "").concat(e).concat(n.length ? " Selector: ".concat(n.join(" | ")) : ""));
}
var Di = function(t, r, n) {
  if (t === "content") {
    var o = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, i = ["normal", "none", "initial", "inherit", "unset"];
    (typeof r != "string" || i.indexOf(r) === -1 && !o.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")) && Pn("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(r, "\"'`."), n);
  }
}, Bi = function(t, r, n) {
  t === "animation" && n.hashId && r !== "none" && Pn("You seem to be using hashed animation '".concat(r, "', in which case 'animationName' with Keyframe as value is recommended."), n);
}, Br = "data-ant-cssinjs-cache-path", On = "_FILE_STYLE__", Ee, Ln = !0;
function zi() {
  if (!Ee && (Ee = {}, ge())) {
    var e = document.createElement("div");
    e.className = Br, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(o) {
      var i = o.split(":"), a = R(i, 2), c = a[0], s = a[1];
      Ee[c] = s;
    });
    var r = document.querySelector("style[".concat(Br, "]"));
    if (r) {
      var n;
      Ln = !1, (n = r.parentNode) === null || n === void 0 || n.removeChild(r);
    }
    document.body.removeChild(e);
  }
}
function Fi(e) {
  return zi(), !!Ee[e];
}
function Ni(e) {
  var t = Ee[e], r = null;
  if (t && ge())
    if (Ln)
      r = On;
    else {
      var n = document.querySelector("style[".concat(ie, '="').concat(Ee[e], '"]'));
      n ? r = n.innerHTML : delete Ee[e];
    }
  return [r, t];
}
var In = "_skip_check_", Hn = "_multi_value_";
function ct(e) {
  var t = Wt(Ii(e), ji);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function $i(e) {
  return $(e) === "object" && e && (In in e || Hn in e);
}
function zr(e, t, r) {
  if (!t)
    return e;
  var n = ".".concat(t), o = r === "low" ? ":where(".concat(n, ")") : n, i = e.split(",").map(function(a) {
    var c, s = a.trim().split(/\s+/), u = s[0] || "", l = ((c = u.match(/^\w+/)) === null || c === void 0 ? void 0 : c[0]) || "";
    return u = "".concat(l).concat(o).concat(u.slice(l.length)), [u].concat(xe(s.slice(1))).join(" ");
  });
  return i.join(",");
}
var Vi = function e(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, o = n.root, i = n.injectHash, a = n.parentSelectors, c = r.hashId, s = r.layer, u = r.path, l = r.hashPriority, d = r.transformers, f = d === void 0 ? [] : d, p = r.linters, y = p === void 0 ? [] : p, h = "", v = {};
  function S(x) {
    var g = x.getName(c);
    if (!v[g]) {
      var E = e(x.style, r, {
        root: !1,
        parentSelectors: a
      }), m = R(E, 1), C = m[0];
      v[g] = "@keyframes ".concat(x.getName(c)).concat(C);
    }
  }
  function b(x) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return x.forEach(function(E) {
      Array.isArray(E) ? b(E, g) : E && g.push(E);
    }), g;
  }
  var T = b(Array.isArray(t) ? t : [t]);
  return T.forEach(function(x) {
    var g = typeof x == "string" && !o ? {} : x;
    if (typeof g == "string")
      h += "".concat(g, `
`);
    else if (g._keyframe)
      S(g);
    else {
      var E = f.reduce(function(m, C) {
        var I;
        return (C == null || (I = C.visit) === null || I === void 0 ? void 0 : I.call(C, m)) || m;
      }, g);
      Object.keys(E).forEach(function(m) {
        var C = E[m];
        if ($(C) === "object" && C && (m !== "animationName" || !C._keyframe) && !$i(C)) {
          var I = !1, L = m.trim(), B = !1;
          (o || i) && c ? L.startsWith("@") ? I = !0 : L === "&" ? L = zr("", c, l) : L = zr(m, c, l) : o && !c && (L === "&" || L === "") && (L = "", B = !0);
          var H = e(C, r, {
            root: B,
            injectHash: I,
            parentSelectors: [].concat(xe(a), [L])
          }), P = R(H, 2), w = P[0], O = P[1];
          v = k(k({}, v), O), h += "".concat(L).concat(w);
        } else {
          let V = function(K, X) {
            process.env.NODE_ENV !== "production" && ($(C) !== "object" || !(C != null && C[In])) && [Di, Bi].concat(xe(y)).forEach(function(F) {
              return F(K, X, {
                path: u,
                hashId: c,
                parentSelectors: a
              });
            });
            var W = K.replace(/[A-Z]/g, function(F) {
              return "-".concat(F.toLowerCase());
            }), N = X;
            !bi[K] && typeof N == "number" && N !== 0 && (N = "".concat(N, "px")), K === "animationName" && X !== null && X !== void 0 && X._keyframe && (S(X), N = X.getName(c)), h += "".concat(W, ":").concat(N, ";");
          };
          var z, G = (z = C == null ? void 0 : C.value) !== null && z !== void 0 ? z : C;
          $(C) === "object" && C !== null && C !== void 0 && C[Hn] && Array.isArray(G) ? G.forEach(function(K) {
            V(m, K);
          }) : V(m, G);
        }
      });
    }
  }), o ? s && (h && (h = "@layer ".concat(s.name, " {").concat(h, "}")), s.dependencies && (v["@layer ".concat(s.name)] = s.dependencies.map(function(x) {
    return "@layer ".concat(x, ", ").concat(s.name, ";");
  }).join(`
`))) : h = "{".concat(h, "}"), [h, v];
};
function jn(e, t) {
  return Ve("".concat(e.join("%")).concat(t));
}
function Wi() {
  return null;
}
var Dn = "style";
function Fr(e, t) {
  var r = e.token, n = e.path, o = e.hashId, i = e.layer, a = e.nonce, c = e.clientOnly, s = e.order, u = s === void 0 ? 0 : s, l = M.useContext(yt), d = l.autoClear, f = l.mock, p = l.defaultCache, y = l.hashPriority, h = l.container, v = l.ssrInline, S = l.transformers, b = l.linters, T = l.cache, x = l.layer, g = r._tokenKey, E = [g];
  x && E.push("layer"), E.push.apply(E, xe(n));
  var m = Ft;
  process.env.NODE_ENV !== "production" && f !== void 0 && (m = f === "client");
  var C = mr(
    Dn,
    E,
    // Create cache if needed
    function() {
      var P = E.join("|");
      if (Fi(P)) {
        var w = Ni(P), O = R(w, 2), z = O[0], G = O[1];
        if (z)
          return [z, g, G, {}, c, u];
      }
      var V = t(), K = Vi(V, {
        hashId: o,
        hashPriority: y,
        layer: x ? i : void 0,
        path: n.join("-"),
        transformers: S,
        linters: b
      }), X = R(K, 2), W = X[0], N = X[1], F = ct(W), Q = jn(E, F);
      return [F, g, Q, N, c, u];
    },
    // Remove cache if no need
    function(P, w) {
      var O = R(P, 3), z = O[2];
      (w || d) && Ft && Sn(z, {
        mark: ie
      });
    },
    // Effect: Inject style here
    function(P) {
      var w = R(P, 4), O = w[0];
      w[1];
      var z = w[2], G = w[3];
      if (m && O !== On) {
        var V = {
          mark: ie,
          prepend: x ? !1 : "queue",
          attachTo: h,
          priority: u
        }, K = typeof a == "function" ? a() : a;
        K && (V.csp = {
          nonce: K
        });
        var X = [], W = [];
        Object.keys(G).forEach(function(F) {
          F.startsWith("@layer") ? X.push(F) : W.push(F);
        }), X.forEach(function(F) {
          Ne(ct(G[F]), "_layer-".concat(F), k(k({}, V), {}, {
            prepend: !0
          }));
        });
        var N = Ne(O, z, V);
        N[he] = T.instanceId, N.setAttribute(Oe, g), process.env.NODE_ENV !== "production" && N.setAttribute(Xo, E.join("|")), W.forEach(function(F) {
          Ne(ct(G[F]), "_effect-".concat(F), V);
        });
      }
    }
  ), I = R(C, 3), L = I[0], B = I[1], H = I[2];
  return function(P) {
    var w;
    if (!v || m || !p)
      w = /* @__PURE__ */ M.createElement(Wi, null);
    else {
      var O;
      w = /* @__PURE__ */ M.createElement("style", an({}, (O = {}, A(O, Oe, B), A(O, ie, H), O), {
        dangerouslySetInnerHTML: {
          __html: L
        }
      }));
    }
    return /* @__PURE__ */ M.createElement(M.Fragment, null, w, P);
  };
}
var Xi = function(t, r, n) {
  var o = R(t, 6), i = o[0], a = o[1], c = o[2], s = o[3], u = o[4], l = o[5], d = n || {}, f = d.plain;
  if (u)
    return null;
  var p = i, y = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(l)
  };
  return p = dt(i, a, c, y, f), s && Object.keys(s).forEach(function(h) {
    if (!r[h]) {
      r[h] = !0;
      var v = ct(s[h]), S = dt(v, a, "_effect-".concat(h), y, f);
      h.startsWith("@layer") ? p = S + p : p += S;
    }
  }), [l, c, p];
}, Bn = "cssVar", Ui = function(t, r) {
  var n = t.key, o = t.prefix, i = t.unitless, a = t.ignore, c = t.token, s = t.scope, u = s === void 0 ? "" : s, l = ut(yt), d = l.cache.instanceId, f = l.container, p = c._tokenKey, y = [].concat(xe(t.path), [n, u, p]), h = mr(Bn, y, function() {
    var v = r(), S = xn(v, n, {
      prefix: o,
      unitless: i,
      ignore: a,
      scope: u
    }), b = R(S, 2), T = b[0], x = b[1], g = jn(y, x);
    return [T, x, g, n];
  }, function(v) {
    var S = R(v, 3), b = S[2];
    Ft && Sn(b, {
      mark: ie
    });
  }, function(v) {
    var S = R(v, 3), b = S[1], T = S[2];
    if (b) {
      var x = Ne(b, T, {
        mark: ie,
        prepend: "queue",
        attachTo: f,
        priority: -999
      });
      x[he] = d, x.setAttribute(Oe, n);
    }
  });
  return h;
}, Gi = function(t, r, n) {
  var o = R(t, 4), i = o[1], a = o[2], c = o[3], s = n || {}, u = s.plain;
  if (!i)
    return null;
  var l = -999, d = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(l)
  }, f = dt(i, c, a, d, u);
  return [l, a, f];
}, Be;
Be = {}, A(Be, Dn, Xi), A(Be, Tn, yi), A(Be, Bn, Gi);
function Me(e) {
  return e.notSplit = !0, e;
}
Me(["borderTop", "borderBottom"]), Me(["borderTop"]), Me(["borderBottom"]), Me(["borderLeft", "borderRight"]), Me(["borderLeft"]), Me(["borderRight"]);
const zn = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, vt = Object.assign(Object.assign({}, zn), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), Y = Math.round;
function kt(e, t) {
  const r = e.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], n = r.map((o) => parseFloat(o));
  for (let o = 0; o < 3; o += 1)
    n[o] = t(n[o] || 0, r[o] || "", o);
  return r[3] ? n[3] = r[3].includes("%") ? n[3] / 100 : n[3] : n[3] = 1, n;
}
const Nr = (e, t, r) => r === 0 ? e : e / 100;
function ze(e, t) {
  const r = t || 255;
  return e > r ? r : e < 0 ? 0 : e;
}
class q {
  constructor(t) {
    A(this, "isValid", !0), A(this, "r", 0), A(this, "g", 0), A(this, "b", 0), A(this, "a", 1), A(this, "_h", void 0), A(this, "_s", void 0), A(this, "_l", void 0), A(this, "_v", void 0), A(this, "_max", void 0), A(this, "_min", void 0), A(this, "_brightness", void 0);
    function r(n) {
      return n[0] in t && n[1] in t && n[2] in t;
    }
    if (t) if (typeof t == "string") {
      let o = function(i) {
        return n.startsWith(i);
      };
      const n = t.trim();
      /^#?[A-F\d]{3,8}$/i.test(n) ? this.fromHexString(n) : o("rgb") ? this.fromRgbString(n) : o("hsl") ? this.fromHslString(n) : (o("hsv") || o("hsb")) && this.fromHsvString(n);
    } else if (t instanceof q)
      this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
    else if (r("rgb"))
      this.r = ze(t.r), this.g = ze(t.g), this.b = ze(t.b), this.a = typeof t.a == "number" ? ze(t.a, 1) : 1;
    else if (r("hsl"))
      this.fromHsl(t);
    else if (r("hsv"))
      this.fromHsv(t);
    else
      throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const r = this.toHsv();
    return r.h = t, this._c(r);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(i) {
      const a = i / 255;
      return a <= 0.03928 ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4);
    }
    const r = t(this.r), n = t(this.g), o = t(this.b);
    return 0.2126 * r + 0.7152 * n + 0.0722 * o;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = Y(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const r = this.getHue(), n = this.getSaturation();
    let o = this.getLightness() - t / 100;
    return o < 0 && (o = 0), this._c({
      h: r,
      s: n,
      l: o,
      a: this.a
    });
  }
  lighten(t = 10) {
    const r = this.getHue(), n = this.getSaturation();
    let o = this.getLightness() + t / 100;
    return o > 1 && (o = 1), this._c({
      h: r,
      s: n,
      l: o,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, r = 50) {
    const n = this._c(t), o = r / 100, i = (c) => (n[c] - this[c]) * o + this[c], a = {
      r: Y(i("r")),
      g: Y(i("g")),
      b: Y(i("b")),
      a: Y(i("a") * 100) / 100
    };
    return this._c(a);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const r = this._c(t), n = this.a + r.a * (1 - this.a), o = (i) => Y((this[i] * this.a + r[i] * r.a * (1 - this.a)) / n);
    return this._c({
      r: o("r"),
      g: o("g"),
      b: o("b"),
      a: n
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const r = (this.r || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const n = (this.g || 0).toString(16);
    t += n.length === 2 ? n : "0" + n;
    const o = (this.b || 0).toString(16);
    if (t += o.length === 2 ? o : "0" + o, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const i = Y(this.a * 255).toString(16);
      t += i.length === 2 ? i : "0" + i;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), r = Y(this.getSaturation() * 100), n = Y(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${r}%,${n}%,${this.a})` : `hsl(${t},${r}%,${n}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, r, n) {
    const o = this.clone();
    return o[t] = ze(r, n), o;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const r = t.replace("#", "");
    function n(o, i) {
      return parseInt(r[o] + r[i || o], 16);
    }
    r.length < 6 ? (this.r = n(0), this.g = n(1), this.b = n(2), this.a = r[3] ? n(3) / 255 : 1) : (this.r = n(0, 1), this.g = n(2, 3), this.b = n(4, 5), this.a = r[6] ? n(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: r,
    l: n,
    a: o
  }) {
    if (this._h = t % 360, this._s = r, this._l = n, this.a = typeof o == "number" ? o : 1, r <= 0) {
      const f = Y(n * 255);
      this.r = f, this.g = f, this.b = f;
    }
    let i = 0, a = 0, c = 0;
    const s = t / 60, u = (1 - Math.abs(2 * n - 1)) * r, l = u * (1 - Math.abs(s % 2 - 1));
    s >= 0 && s < 1 ? (i = u, a = l) : s >= 1 && s < 2 ? (i = l, a = u) : s >= 2 && s < 3 ? (a = u, c = l) : s >= 3 && s < 4 ? (a = l, c = u) : s >= 4 && s < 5 ? (i = l, c = u) : s >= 5 && s < 6 && (i = u, c = l);
    const d = n - u / 2;
    this.r = Y((i + d) * 255), this.g = Y((a + d) * 255), this.b = Y((c + d) * 255);
  }
  fromHsv({
    h: t,
    s: r,
    v: n,
    a: o
  }) {
    this._h = t % 360, this._s = r, this._v = n, this.a = typeof o == "number" ? o : 1;
    const i = Y(n * 255);
    if (this.r = i, this.g = i, this.b = i, r <= 0)
      return;
    const a = t / 60, c = Math.floor(a), s = a - c, u = Y(n * (1 - r) * 255), l = Y(n * (1 - r * s) * 255), d = Y(n * (1 - r * (1 - s)) * 255);
    switch (c) {
      case 0:
        this.g = d, this.b = u;
        break;
      case 1:
        this.r = l, this.b = u;
        break;
      case 2:
        this.r = u, this.b = d;
        break;
      case 3:
        this.r = u, this.g = l;
        break;
      case 4:
        this.r = d, this.g = u;
        break;
      case 5:
      default:
        this.g = u, this.b = l;
        break;
    }
  }
  fromHsvString(t) {
    const r = kt(t, Nr);
    this.fromHsv({
      h: r[0],
      s: r[1],
      v: r[2],
      a: r[3]
    });
  }
  fromHslString(t) {
    const r = kt(t, Nr);
    this.fromHsl({
      h: r[0],
      s: r[1],
      l: r[2],
      a: r[3]
    });
  }
  fromRgbString(t) {
    const r = kt(t, (n, o) => (
      // Convert percentage to number. e.g. 50% -> 128
      o.includes("%") ? Y(n / 100 * 255) : n
    ));
    this.r = r[0], this.g = r[1], this.b = r[2], this.a = r[3];
  }
}
var Qe = 2, $r = 0.16, Ki = 0.05, Yi = 0.05, qi = 0.15, Fn = 5, Nn = 4, Qi = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function Vr(e, t, r) {
  var n;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? n = r ? Math.round(e.h) - Qe * t : Math.round(e.h) + Qe * t : n = r ? Math.round(e.h) + Qe * t : Math.round(e.h) - Qe * t, n < 0 ? n += 360 : n >= 360 && (n -= 360), n;
}
function Wr(e, t, r) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var n;
  return r ? n = e.s - $r * t : t === Nn ? n = e.s + $r : n = e.s + Ki * t, n > 1 && (n = 1), r && t === Fn && n > 0.1 && (n = 0.1), n < 0.06 && (n = 0.06), Math.round(n * 100) / 100;
}
function Xr(e, t, r) {
  var n;
  return r ? n = e.v + Yi * t : n = e.v - qi * t, n = Math.max(0, Math.min(1, n)), Math.round(n * 100) / 100;
}
function $n(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [], n = new q(e), o = n.toHsv(), i = Fn; i > 0; i -= 1) {
    var a = new q({
      h: Vr(o, i, !0),
      s: Wr(o, i, !0),
      v: Xr(o, i, !0)
    });
    r.push(a);
  }
  r.push(n);
  for (var c = 1; c <= Nn; c += 1) {
    var s = new q({
      h: Vr(o, c),
      s: Wr(o, c),
      v: Xr(o, c)
    });
    r.push(s);
  }
  return t.theme === "dark" ? Qi.map(function(u) {
    var l = u.index, d = u.amount;
    return new q(t.backgroundColor || "#141414").mix(r[l], d).toHexString();
  }) : r.map(function(u) {
    return u.toHexString();
  });
}
var Mt = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Xt = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
Xt.primary = Xt[5];
var Ut = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
Ut.primary = Ut[5];
var Gt = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
Gt.primary = Gt[5];
var Kt = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
Kt.primary = Kt[5];
var Yt = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
Yt.primary = Yt[5];
var qt = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
qt.primary = qt[5];
var Qt = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
Qt.primary = Qt[5];
var Zt = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
Zt.primary = Zt[5];
var Jt = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
Jt.primary = Jt[5];
var er = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
er.primary = er[5];
var tr = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
tr.primary = tr[5];
var rr = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
rr.primary = rr[5];
var nr = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
nr.primary = nr[5];
var wt = {
  red: Xt,
  volcano: Ut,
  orange: Gt,
  gold: Kt,
  yellow: Yt,
  lime: qt,
  green: Qt,
  cyan: Zt,
  blue: Jt,
  geekblue: er,
  purple: tr,
  magenta: rr,
  grey: nr
};
function Zi(e, {
  generateColorPalettes: t,
  generateNeutralColorPalettes: r
}) {
  const {
    colorSuccess: n,
    colorWarning: o,
    colorError: i,
    colorInfo: a,
    colorPrimary: c,
    colorBgBase: s,
    colorTextBase: u
  } = e, l = t(c), d = t(n), f = t(o), p = t(i), y = t(a), h = r(s, u), v = e.colorLink || e.colorInfo, S = t(v), b = new q(p[1]).mix(new q(p[3]), 50).toHexString();
  return Object.assign(Object.assign({}, h), {
    colorPrimaryBg: l[1],
    colorPrimaryBgHover: l[2],
    colorPrimaryBorder: l[3],
    colorPrimaryBorderHover: l[4],
    colorPrimaryHover: l[5],
    colorPrimary: l[6],
    colorPrimaryActive: l[7],
    colorPrimaryTextHover: l[8],
    colorPrimaryText: l[9],
    colorPrimaryTextActive: l[10],
    colorSuccessBg: d[1],
    colorSuccessBgHover: d[2],
    colorSuccessBorder: d[3],
    colorSuccessBorderHover: d[4],
    colorSuccessHover: d[4],
    colorSuccess: d[6],
    colorSuccessActive: d[7],
    colorSuccessTextHover: d[8],
    colorSuccessText: d[9],
    colorSuccessTextActive: d[10],
    colorErrorBg: p[1],
    colorErrorBgHover: p[2],
    colorErrorBgFilledHover: b,
    colorErrorBgActive: p[3],
    colorErrorBorder: p[3],
    colorErrorBorderHover: p[4],
    colorErrorHover: p[5],
    colorError: p[6],
    colorErrorActive: p[7],
    colorErrorTextHover: p[8],
    colorErrorText: p[9],
    colorErrorTextActive: p[10],
    colorWarningBg: f[1],
    colorWarningBgHover: f[2],
    colorWarningBorder: f[3],
    colorWarningBorderHover: f[4],
    colorWarningHover: f[4],
    colorWarning: f[6],
    colorWarningActive: f[7],
    colorWarningTextHover: f[8],
    colorWarningText: f[9],
    colorWarningTextActive: f[10],
    colorInfoBg: y[1],
    colorInfoBgHover: y[2],
    colorInfoBorder: y[3],
    colorInfoBorderHover: y[4],
    colorInfoHover: y[4],
    colorInfo: y[6],
    colorInfoActive: y[7],
    colorInfoTextHover: y[8],
    colorInfoText: y[9],
    colorInfoTextActive: y[10],
    colorLinkHover: S[4],
    colorLink: S[6],
    colorLinkActive: S[7],
    colorBgMask: new q("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const Ji = (e) => {
  let t = e, r = e, n = e, o = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? r = 4 : e < 8 && e >= 7 ? r = 5 : e < 14 && e >= 8 ? r = 6 : e < 16 && e >= 14 ? r = 7 : e >= 16 && (r = 8), e < 6 && e >= 2 ? n = 1 : e >= 6 && (n = 2), e > 4 && e < 8 ? o = 4 : e >= 8 && (o = 6), {
    borderRadius: e,
    borderRadiusXS: n,
    borderRadiusSM: r,
    borderRadiusLG: t,
    borderRadiusOuter: o
  };
};
function ea(e) {
  const {
    motionUnit: t,
    motionBase: r,
    borderRadius: n,
    lineWidth: o
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(r + t).toFixed(1)}s`,
    motionDurationMid: `${(r + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(r + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: o + 1
  }, Ji(n));
}
const ta = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function ra(e) {
  return (e + 8) / e;
}
function na(e) {
  const t = Array.from({
    length: 10
  }).map((r, n) => {
    const o = n - 1, i = e * Math.pow(Math.E, o / 5), a = n > 1 ? Math.floor(i) : Math.ceil(i);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((r) => ({
    size: r,
    lineHeight: ra(r)
  }));
}
const oa = (e) => {
  const t = na(e), r = t.map((l) => l.size), n = t.map((l) => l.lineHeight), o = r[1], i = r[0], a = r[2], c = n[1], s = n[0], u = n[2];
  return {
    fontSizeSM: i,
    fontSize: o,
    fontSizeLG: a,
    fontSizeXL: r[3],
    fontSizeHeading1: r[6],
    fontSizeHeading2: r[5],
    fontSizeHeading3: r[4],
    fontSizeHeading4: r[3],
    fontSizeHeading5: r[2],
    lineHeight: c,
    lineHeightLG: u,
    lineHeightSM: s,
    fontHeight: Math.round(c * o),
    fontHeightLG: Math.round(u * a),
    fontHeightSM: Math.round(s * i),
    lineHeightHeading1: n[6],
    lineHeightHeading2: n[5],
    lineHeightHeading3: n[4],
    lineHeightHeading4: n[3],
    lineHeightHeading5: n[2]
  };
};
function ia(e) {
  const {
    sizeUnit: t,
    sizeStep: r
  } = e;
  return {
    sizeXXL: t * (r + 8),
    // 48
    sizeXL: t * (r + 4),
    // 32
    sizeLG: t * (r + 2),
    // 24
    sizeMD: t * (r + 1),
    // 20
    sizeMS: t * r,
    // 16
    size: t * r,
    // 16
    sizeSM: t * (r - 1),
    // 12
    sizeXS: t * (r - 2),
    // 8
    sizeXXS: t * (r - 3)
    // 4
  };
}
const te = (e, t) => new q(e).setA(t).toRgbString(), Fe = (e, t) => new q(e).darken(t).toHexString(), aa = (e) => {
  const t = $n(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, sa = (e, t) => {
  const r = e || "#fff", n = t || "#000";
  return {
    colorBgBase: r,
    colorTextBase: n,
    colorText: te(n, 0.88),
    colorTextSecondary: te(n, 0.65),
    colorTextTertiary: te(n, 0.45),
    colorTextQuaternary: te(n, 0.25),
    colorFill: te(n, 0.15),
    colorFillSecondary: te(n, 0.06),
    colorFillTertiary: te(n, 0.04),
    colorFillQuaternary: te(n, 0.02),
    colorBgSolid: te(n, 1),
    colorBgSolidHover: te(n, 0.75),
    colorBgSolidActive: te(n, 0.95),
    colorBgLayout: Fe(r, 4),
    colorBgContainer: Fe(r, 0),
    colorBgElevated: Fe(r, 0),
    colorBgSpotlight: te(n, 0.85),
    colorBgBlur: "transparent",
    colorBorder: Fe(r, 15),
    colorBorderSecondary: Fe(r, 6)
  };
};
function ca(e) {
  Mt.pink = Mt.magenta, wt.pink = wt.magenta;
  const t = Object.keys(zn).map((r) => {
    const n = e[r] === Mt[r] ? wt[r] : $n(e[r]);
    return Array.from({
      length: 10
    }, () => 1).reduce((o, i, a) => (o[`${r}-${a + 1}`] = n[a], o[`${r}${a + 1}`] = n[a], o), {});
  }).reduce((r, n) => (r = Object.assign(Object.assign({}, r), n), r), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), Zi(e, {
    generateColorPalettes: aa,
    generateNeutralColorPalettes: sa
  })), oa(e.fontSize)), ia(e)), ta(e)), ea(e));
}
const ua = Ko(ca), la = {
  token: vt,
  override: {
    override: vt
  },
  hashed: !0
}, fa = /* @__PURE__ */ be.createContext(la), Ur = "ant", Vn = "anticon", ls = ["outlined", "borderless", "filled", "underlined"], da = (e, t) => t || (e ? `${Ur}-${e}` : Ur), or = /* @__PURE__ */ M.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: da,
  iconPrefixCls: Vn
}), Gr = {};
function fs(e) {
  const t = M.useContext(or), {
    getPrefixCls: r,
    direction: n,
    getPopupContainer: o
  } = t, i = t[e];
  return Object.assign(Object.assign({
    classNames: Gr,
    styles: Gr
  }, i), {
    getPrefixCls: r,
    direction: n,
    getPopupContainer: o
  });
}
var Wn = /* @__PURE__ */ de(function e() {
  fe(this, e);
}), Xn = "CALC_UNIT", va = new RegExp(Xn, "g");
function Rt(e) {
  return typeof e == "number" ? "".concat(e).concat(Xn) : e;
}
var ha = /* @__PURE__ */ function(e) {
  ht(r, e);
  var t = pt(r);
  function r(n, o) {
    var i;
    fe(this, r), i = t.call(this), A(Se(i), "result", ""), A(Se(i), "unitlessCssVar", void 0), A(Se(i), "lowPriority", void 0);
    var a = $(n);
    return i.unitlessCssVar = o, n instanceof r ? i.result = "(".concat(n.result, ")") : a === "number" ? i.result = Rt(n) : a === "string" && (i.result = n), i;
  }
  return de(r, [{
    key: "add",
    value: function(o) {
      return o instanceof r ? this.result = "".concat(this.result, " + ").concat(o.getResult()) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " + ").concat(Rt(o))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(o) {
      return o instanceof r ? this.result = "".concat(this.result, " - ").concat(o.getResult()) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " - ").concat(Rt(o))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(o) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), o instanceof r ? this.result = "".concat(this.result, " * ").concat(o.getResult(!0)) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " * ").concat(o)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(o) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), o instanceof r ? this.result = "".concat(this.result, " / ").concat(o.getResult(!0)) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " / ").concat(o)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(o) {
      return this.lowPriority || o ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(o) {
      var i = this, a = o || {}, c = a.unit, s = !0;
      return typeof c == "boolean" ? s = c : Array.from(this.unitlessCssVar).some(function(u) {
        return i.result.includes(u);
      }) && (s = !1), this.result = this.result.replace(va, s ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), r;
}(Wn), pa = /* @__PURE__ */ function(e) {
  ht(r, e);
  var t = pt(r);
  function r(n) {
    var o;
    return fe(this, r), o = t.call(this), A(Se(o), "result", 0), n instanceof r ? o.result = n.result : typeof n == "number" && (o.result = n), o;
  }
  return de(r, [{
    key: "add",
    value: function(o) {
      return o instanceof r ? this.result += o.result : typeof o == "number" && (this.result += o), this;
    }
  }, {
    key: "sub",
    value: function(o) {
      return o instanceof r ? this.result -= o.result : typeof o == "number" && (this.result -= o), this;
    }
  }, {
    key: "mul",
    value: function(o) {
      return o instanceof r ? this.result *= o.result : typeof o == "number" && (this.result *= o), this;
    }
  }, {
    key: "div",
    value: function(o) {
      return o instanceof r ? this.result /= o.result : typeof o == "number" && (this.result /= o), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), r;
}(Wn), ga = function(t, r) {
  var n = t === "css" ? ha : pa;
  return function(o) {
    return new n(o, r);
  };
}, Kr = function(t, r) {
  return "".concat([r, t.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function ir(e) {
  var t = M.useRef();
  t.current = e;
  var r = M.useCallback(function() {
    for (var n, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(i));
  }, []);
  return r;
}
function ar(e) {
  var t = M.useRef(!1), r = M.useState(e), n = R(r, 2), o = n[0], i = n[1];
  M.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(c, s) {
    s && t.current || i(c);
  }
  return [o, a];
}
function Yr(e, t, r, n) {
  var o = k({}, t[e]);
  if (n != null && n.deprecatedTokens) {
    var i = n.deprecatedTokens;
    i.forEach(function(c) {
      var s = R(c, 2), u = s[0], l = s[1];
      if (process.env.NODE_ENV !== "production" && Xe(!(o != null && o[u]), "Component Token `".concat(String(u), "` of ").concat(String(e), " is deprecated. Please use `").concat(String(l), "` instead.")), o != null && o[u] || o != null && o[l]) {
        var d;
        (d = o[l]) !== null && d !== void 0 || (o[l] = o == null ? void 0 : o[u]);
      }
    });
  }
  var a = k(k({}, r), o);
  return Object.keys(a).forEach(function(c) {
    a[c] === t[c] && delete a[c];
  }), a;
}
var Un = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", sr = !0;
function Gn() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  if (!Un)
    return Object.assign.apply(Object, [{}].concat(t));
  sr = !1;
  var n = {};
  return t.forEach(function(o) {
    if ($(o) === "object") {
      var i = Object.keys(o);
      i.forEach(function(a) {
        Object.defineProperty(n, a, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return o[a];
          }
        });
      });
    }
  }), sr = !0, n;
}
var qr = {};
function ma() {
}
var ya = function(t) {
  var r, n = t, o = ma;
  return Un && typeof Proxy < "u" && (r = /* @__PURE__ */ new Set(), n = new Proxy(t, {
    get: function(a, c) {
      if (sr) {
        var s;
        (s = r) === null || s === void 0 || s.add(c);
      }
      return a[c];
    }
  }), o = function(a, c) {
    var s;
    qr[a] = {
      global: Array.from(r),
      component: k(k({}, (s = qr[a]) === null || s === void 0 ? void 0 : s.component), c)
    };
  }), {
    token: n,
    keys: r,
    flush: o
  };
};
function Qr(e, t, r) {
  if (typeof r == "function") {
    var n;
    return r(Gn(t, (n = t[e]) !== null && n !== void 0 ? n : {}));
  }
  return r ?? {};
}
function ba(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
        n[o] = arguments[o];
      return "max(".concat(n.map(function(i) {
        return Nt(i);
      }).join(","), ")");
    },
    min: function() {
      for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
        n[o] = arguments[o];
      return "min(".concat(n.map(function(i) {
        return Nt(i);
      }).join(","), ")");
    }
  };
}
var Sa = 1e3 * 60 * 10, Ea = /* @__PURE__ */ function() {
  function e() {
    fe(this, e), A(this, "map", /* @__PURE__ */ new Map()), A(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), A(this, "nextID", 0), A(this, "lastAccessBeat", /* @__PURE__ */ new Map()), A(this, "accessBeat", 0);
  }
  return de(e, [{
    key: "set",
    value: function(r, n) {
      this.clear();
      var o = this.getCompositeKey(r);
      this.map.set(o, n), this.lastAccessBeat.set(o, Date.now());
    }
  }, {
    key: "get",
    value: function(r) {
      var n = this.getCompositeKey(r), o = this.map.get(n);
      return this.lastAccessBeat.set(n, Date.now()), this.accessBeat += 1, o;
    }
  }, {
    key: "getCompositeKey",
    value: function(r) {
      var n = this, o = r.map(function(i) {
        return i && $(i) === "object" ? "obj_".concat(n.getObjectID(i)) : "".concat($(i), "_").concat(i);
      });
      return o.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(r) {
      if (this.objectIDMap.has(r))
        return this.objectIDMap.get(r);
      var n = this.nextID;
      return this.objectIDMap.set(r, n), this.nextID += 1, n;
    }
  }, {
    key: "clear",
    value: function() {
      var r = this;
      if (this.accessBeat > 1e4) {
        var n = Date.now();
        this.lastAccessBeat.forEach(function(o, i) {
          n - o > Sa && (r.map.delete(i), r.lastAccessBeat.delete(i));
        }), this.accessBeat = 0;
      }
    }
  }]), e;
}(), Zr = new Ea();
function xa(e, t) {
  return be.useMemo(function() {
    var r = Zr.get(t);
    if (r)
      return r;
    var n = e();
    return Zr.set(t, n), n;
  }, t);
}
var Ca = function() {
  return {};
};
function Ta(e) {
  var t = e.useCSP, r = t === void 0 ? Ca : t, n = e.useToken, o = e.usePrefix, i = e.getResetStyles, a = e.getCommonStyle, c = e.getCompUnitless;
  function s(f, p, y, h) {
    var v = Array.isArray(f) ? f[0] : f;
    function S(C) {
      return "".concat(String(v)).concat(C.slice(0, 1).toUpperCase()).concat(C.slice(1));
    }
    var b = (h == null ? void 0 : h.unitless) || {}, T = typeof c == "function" ? c(f) : {}, x = k(k({}, T), {}, A({}, S("zIndexPopup"), !0));
    Object.keys(b).forEach(function(C) {
      x[S(C)] = b[C];
    });
    var g = k(k({}, h), {}, {
      unitless: x,
      prefixToken: S
    }), E = l(f, p, y, g), m = u(v, y, g);
    return function(C) {
      var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : C, L = E(C, I), B = R(L, 2), H = B[1], P = m(I), w = R(P, 2), O = w[0], z = w[1];
      return [O, H, z];
    };
  }
  function u(f, p, y) {
    var h = y.unitless, v = y.injectStyle, S = v === void 0 ? !0 : v, b = y.prefixToken, T = y.ignore, x = function(m) {
      var C = m.rootCls, I = m.cssVar, L = I === void 0 ? {} : I, B = n(), H = B.realToken;
      return Ui({
        path: [f],
        prefix: L.prefix,
        key: L.key,
        unitless: h,
        ignore: T,
        token: H,
        scope: C
      }, function() {
        var P = Qr(f, H, p), w = Yr(f, H, P, {
          deprecatedTokens: y == null ? void 0 : y.deprecatedTokens
        });
        return Object.keys(P).forEach(function(O) {
          w[b(O)] = w[O], delete w[O];
        }), w;
      }), null;
    }, g = function(m) {
      var C = n(), I = C.cssVar;
      return [function(L) {
        return S && I ? /* @__PURE__ */ be.createElement(be.Fragment, null, /* @__PURE__ */ be.createElement(x, {
          rootCls: m,
          cssVar: I,
          component: f
        }), L) : L;
      }, I == null ? void 0 : I.key];
    };
    return g;
  }
  function l(f, p, y) {
    var h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, v = Array.isArray(f) ? f : [f, f], S = R(v, 1), b = S[0], T = v.join("-"), x = e.layer || {
      name: "antd"
    };
    return function(g) {
      var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : g, m = n(), C = m.theme, I = m.realToken, L = m.hashId, B = m.token, H = m.cssVar, P = o(), w = P.rootPrefixCls, O = P.iconPrefixCls, z = r(), G = H ? "css" : "js", V = xa(function() {
        var Q = /* @__PURE__ */ new Set();
        return H && Object.keys(h.unitless || {}).forEach(function(ue) {
          Q.add(ot(ue, H.prefix)), Q.add(ot(ue, Kr(b, H.prefix)));
        }), ga(G, Q);
      }, [G, b, H == null ? void 0 : H.prefix]), K = ba(G), X = K.max, W = K.min, N = {
        theme: C,
        token: B,
        hashId: L,
        nonce: function() {
          return z.nonce;
        },
        clientOnly: h.clientOnly,
        layer: x,
        // antd is always at top of styles
        order: h.order || -999
      };
      typeof i == "function" && Fr(k(k({}, N), {}, {
        clientOnly: !1,
        path: ["Shared", w]
      }), function() {
        return i(B, {
          prefix: {
            rootPrefixCls: w,
            iconPrefixCls: O
          },
          csp: z
        });
      });
      var F = Fr(k(k({}, N), {}, {
        path: [T, g, O]
      }), function() {
        if (h.injectStyle === !1)
          return [];
        var Q = ya(B), ue = Q.token, Ce = Q.flush, ne = Qr(b, I, y), je = ".".concat(g), Te = Yr(b, I, ne, {
          deprecatedTokens: h.deprecatedTokens
        });
        H && ne && $(ne) === "object" && Object.keys(ne).forEach(function(ke) {
          ne[ke] = "var(".concat(ot(ke, Kr(b, H.prefix)), ")");
        });
        var _e = Gn(ue, {
          componentCls: je,
          prefixCls: g,
          iconCls: ".".concat(O),
          antCls: ".".concat(w),
          calc: V,
          // @ts-ignore
          max: X,
          // @ts-ignore
          min: W
        }, H ? ne : Te), Ae = p(_e, {
          hashId: L,
          prefixCls: g,
          rootPrefixCls: w,
          iconPrefixCls: O
        });
        Ce(b, Te);
        var le = typeof a == "function" ? a(_e, g, E, h.resetFont) : null;
        return [h.resetStyle === !1 ? null : le, Ae];
      });
      return [F, L];
    };
  }
  function d(f, p, y) {
    var h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, v = l(f, p, y, k({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, h)), S = function(T) {
      var x = T.prefixCls, g = T.rootCls, E = g === void 0 ? x : g;
      return v(x, E), null;
    };
    return process.env.NODE_ENV !== "production" && (S.displayName = "SubStyle_".concat(String(Array.isArray(f) ? f.join(".") : f))), S;
  }
  return {
    genStyleHooks: s,
    genSubStyleComponent: d,
    genComponentStyleHook: l
  };
}
const _a = "5.25.4";
function Pt(e) {
  return e >= 0 && e <= 255;
}
function Ze(e, t) {
  const {
    r,
    g: n,
    b: o,
    a: i
  } = new q(e).toRgb();
  if (i < 1)
    return e;
  const {
    r: a,
    g: c,
    b: s
  } = new q(t).toRgb();
  for (let u = 0.01; u <= 1; u += 0.01) {
    const l = Math.round((r - a * (1 - u)) / u), d = Math.round((n - c * (1 - u)) / u), f = Math.round((o - s * (1 - u)) / u);
    if (Pt(l) && Pt(d) && Pt(f))
      return new q({
        r: l,
        g: d,
        b: f,
        a: Math.round(u * 100) / 100
      }).toRgbString();
  }
  return new q({
    r,
    g: n,
    b: o,
    a: 1
  }).toRgbString();
}
var Aa = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function Kn(e) {
  const {
    override: t
  } = e, r = Aa(e, ["override"]), n = Object.assign({}, t);
  Object.keys(vt).forEach((f) => {
    delete n[f];
  });
  const o = Object.assign(Object.assign({}, r), n), i = 480, a = 576, c = 768, s = 992, u = 1200, l = 1600;
  if (o.motion === !1) {
    const f = "0s";
    o.motionDurationFast = f, o.motionDurationMid = f, o.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, o), {
    // ============== Background ============== //
    colorFillContent: o.colorFillSecondary,
    colorFillContentHover: o.colorFill,
    colorFillAlter: o.colorFillQuaternary,
    colorBgContainerDisabled: o.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: o.colorBgContainer,
    colorSplit: Ze(o.colorBorderSecondary, o.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: o.colorTextQuaternary,
    colorTextDisabled: o.colorTextQuaternary,
    colorTextHeading: o.colorText,
    colorTextLabel: o.colorTextSecondary,
    colorTextDescription: o.colorTextTertiary,
    colorTextLightSolid: o.colorWhite,
    colorHighlight: o.colorError,
    colorBgTextHover: o.colorFillSecondary,
    colorBgTextActive: o.colorFill,
    colorIcon: o.colorTextTertiary,
    colorIconHover: o.colorText,
    colorErrorOutline: Ze(o.colorErrorBg, o.colorBgContainer),
    colorWarningOutline: Ze(o.colorWarningBg, o.colorBgContainer),
    // Font
    fontSizeIcon: o.fontSizeSM,
    // Line
    lineWidthFocus: o.lineWidth * 3,
    // Control
    lineWidth: o.lineWidth,
    controlOutlineWidth: o.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: o.controlHeight / 2,
    controlItemBgHover: o.colorFillTertiary,
    controlItemBgActive: o.colorPrimaryBg,
    controlItemBgActiveHover: o.colorPrimaryBgHover,
    controlItemBgActiveDisabled: o.colorFill,
    controlTmpOutline: o.colorFillQuaternary,
    controlOutline: Ze(o.colorPrimaryBg, o.colorBgContainer),
    lineType: o.lineType,
    borderRadius: o.borderRadius,
    borderRadiusXS: o.borderRadiusXS,
    borderRadiusSM: o.borderRadiusSM,
    borderRadiusLG: o.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: o.sizeXXS,
    paddingXS: o.sizeXS,
    paddingSM: o.sizeSM,
    padding: o.size,
    paddingMD: o.sizeMD,
    paddingLG: o.sizeLG,
    paddingXL: o.sizeXL,
    paddingContentHorizontalLG: o.sizeLG,
    paddingContentVerticalLG: o.sizeMS,
    paddingContentHorizontal: o.sizeMS,
    paddingContentVertical: o.sizeSM,
    paddingContentHorizontalSM: o.size,
    paddingContentVerticalSM: o.sizeXS,
    marginXXS: o.sizeXXS,
    marginXS: o.sizeXS,
    marginSM: o.sizeSM,
    margin: o.size,
    marginMD: o.sizeMD,
    marginLG: o.sizeLG,
    marginXL: o.sizeXL,
    marginXXL: o.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: i,
    screenXSMin: i,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: c - 1,
    screenMD: c,
    screenMDMin: c,
    screenMDMax: s - 1,
    screenLG: s,
    screenLGMin: s,
    screenLGMax: u - 1,
    screenXL: u,
    screenXLMin: u,
    screenXLMax: l - 1,
    screenXXL: l,
    screenXXLMin: l,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new q("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new q("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new q("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), n);
}
var Jr = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const Yn = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, ka = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, Ma = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, qn = (e, t, r) => {
  const n = r.getDerivativeToken(e), {
    override: o
  } = t, i = Jr(t, ["override"]);
  let a = Object.assign(Object.assign({}, n), {
    override: o
  });
  return a = Kn(a), i && Object.entries(i).forEach(([c, s]) => {
    const {
      theme: u
    } = s, l = Jr(s, ["theme"]);
    let d = l;
    u && (d = qn(Object.assign(Object.assign({}, a), l), {
      override: l
    }, u)), a[c] = d;
  }), a;
};
function wa() {
  const {
    token: e,
    hashed: t,
    theme: r,
    override: n,
    cssVar: o
  } = be.useContext(fa), i = `${_a}-${t || ""}`, a = r || ua, [c, s, u] = mi(a, [vt, e], {
    salt: i,
    override: n,
    getComputedToken: qn,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: Kn,
    cssVar: o && {
      prefix: o.prefix,
      key: o.key,
      unitless: Yn,
      ignore: ka,
      preserve: Ma
    }
  });
  return [a, u, t ? s : "", c, o];
}
const ds = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, vs = (e, t = !1) => ({
  boxSizing: "border-box",
  margin: 0,
  padding: 0,
  color: e.colorText,
  fontSize: e.fontSize,
  // font-variant: @font-variant-base;
  lineHeight: e.lineHeight,
  listStyle: "none",
  // font-feature-settings: @font-feature-settings-base;
  fontFamily: t ? "inherit" : e.fontFamily
}), Ra = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), hs = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), Pa = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), Oa = (e, t, r, n) => {
  const o = `[class^="${t}"], [class*=" ${t}"]`, i = r ? `.${r}` : o, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let c = {};
  return n !== !1 && (c = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [i]: Object.assign(Object.assign(Object.assign({}, c), a), {
      [o]: a
    })
  };
}, La = (e, t) => ({
  outline: `${Nt(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: t ?? 1,
  transition: "outline-offset 0s, outline 0s"
}), Ia = (e, t) => ({
  "&:focus-visible": Object.assign({}, La(e, t))
}), Ha = (e) => ({
  [`.${e}`]: Object.assign(Object.assign({}, Ra()), {
    [`.${e} .${e}-icon`]: {
      display: "block"
    }
  })
}), ps = (e) => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: e.linkDecoration,
  outline: "none",
  cursor: "pointer",
  transition: `all ${e.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: "none",
  userSelect: "none"
}, Ia(e)), {
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
}), {
  genStyleHooks: gs,
  genComponentStyleHook: ms,
  genSubStyleComponent: ys
} = Ta({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = ut(or);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, r, n, o] = wa();
    return {
      theme: e,
      realToken: t,
      hashId: r,
      token: n,
      cssVar: o
    };
  },
  useCSP: () => {
    const {
      csp: e
    } = ut(or);
    return e ?? {};
  },
  getResetStyles: (e, t) => {
    var r;
    const n = Pa(e);
    return [n, {
      "&": n
    }, Ha((r = t == null ? void 0 : t.prefix.iconPrefixCls) !== null && r !== void 0 ? r : Vn)];
  },
  getCommonStyle: Oa,
  getCompUnitless: () => Yn
});
var ja = ["children"], Qn = /* @__PURE__ */ M.createContext({});
function bs(e) {
  var t = e.children, r = Bt(e, ja);
  return /* @__PURE__ */ M.createElement(Qn.Provider, {
    value: r
  }, t);
}
var Da = /* @__PURE__ */ function(e) {
  ht(r, e);
  var t = pt(r);
  function r() {
    return fe(this, r), t.apply(this, arguments);
  }
  return de(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(M.Component);
function Ba(e) {
  var t = M.useReducer(function(c) {
    return c + 1;
  }, 0), r = R(t, 2), n = r[1], o = M.useRef(e), i = ir(function() {
    return o.current;
  }), a = ir(function(c) {
    o.current = typeof c == "function" ? c(o.current) : c, n();
  });
  return [i, a];
}
var ve = "none", Je = "appear", et = "enter", tt = "leave", en = "none", oe = "prepare", we = "start", Re = "active", Sr = "end", Zn = "prepared";
function tn(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit".concat(e)] = "webkit".concat(t), r["Moz".concat(e)] = "moz".concat(t), r["ms".concat(e)] = "MS".concat(t), r["O".concat(e)] = "o".concat(t.toLowerCase()), r;
}
function za(e, t) {
  var r = {
    animationend: tn("Animation", "AnimationEnd"),
    transitionend: tn("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete r.animationend.animation, "TransitionEvent" in t || delete r.transitionend.transition), r;
}
var Fa = za(ge(), typeof window < "u" ? window : {}), Jn = {};
if (ge()) {
  var Na = document.createElement("div");
  Jn = Na.style;
}
var rt = {};
function eo(e) {
  if (rt[e])
    return rt[e];
  var t = Fa[e];
  if (t)
    for (var r = Object.keys(t), n = r.length, o = 0; o < n; o += 1) {
      var i = r[o];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in Jn)
        return rt[e] = t[i], rt[e];
    }
  return "";
}
var to = eo("animationend"), ro = eo("transitionend"), no = !!(to && ro), rn = to || "animationend", nn = ro || "transitionend";
function on(e, t) {
  if (!e) return null;
  if ($(e) === "object") {
    var r = t.replace(/-\w/g, function(n) {
      return n[1].toUpperCase();
    });
    return e[r];
  }
  return "".concat(e, "-").concat(t);
}
const $a = function(e) {
  var t = ye();
  function r(o) {
    o && (o.removeEventListener(nn, e), o.removeEventListener(rn, e));
  }
  function n(o) {
    t.current && t.current !== o && r(t.current), o && o !== t.current && (o.addEventListener(nn, e), o.addEventListener(rn, e), t.current = o);
  }
  return M.useEffect(function() {
    return function() {
      r(t.current);
    };
  }, []), [n, r];
};
var oo = ge() ? uo : nt;
const Va = function() {
  var e = M.useRef(null);
  function t() {
    ft.cancel(e.current);
  }
  function r(n) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = ft(function() {
      o <= 1 ? n({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : r(n, o - 1);
    });
    e.current = i;
  }
  return M.useEffect(function() {
    return function() {
      t();
    };
  }, []), [r, t];
};
var Wa = [oe, we, Re, Sr], Xa = [oe, Zn], io = !1, Ua = !0;
function ao(e) {
  return e === Re || e === Sr;
}
const Ga = function(e, t, r) {
  var n = ar(en), o = R(n, 2), i = o[0], a = o[1], c = Va(), s = R(c, 2), u = s[0], l = s[1];
  function d() {
    a(oe, !0);
  }
  var f = t ? Xa : Wa;
  return oo(function() {
    if (i !== en && i !== Sr) {
      var p = f.indexOf(i), y = f[p + 1], h = r(i);
      h === io ? a(y, !0) : y && u(function(v) {
        function S() {
          v.isCanceled() || a(y, !0);
        }
        h === !0 ? S() : Promise.resolve(h).then(S);
      });
    }
  }, [e, i]), M.useEffect(function() {
    return function() {
      l();
    };
  }, []), [d, i];
};
function Ka(e, t, r, n) {
  var o = n.motionEnter, i = o === void 0 ? !0 : o, a = n.motionAppear, c = a === void 0 ? !0 : a, s = n.motionLeave, u = s === void 0 ? !0 : s, l = n.motionDeadline, d = n.motionLeaveImmediately, f = n.onAppearPrepare, p = n.onEnterPrepare, y = n.onLeavePrepare, h = n.onAppearStart, v = n.onEnterStart, S = n.onLeaveStart, b = n.onAppearActive, T = n.onEnterActive, x = n.onLeaveActive, g = n.onAppearEnd, E = n.onEnterEnd, m = n.onLeaveEnd, C = n.onVisibleChanged, I = ar(), L = R(I, 2), B = L[0], H = L[1], P = Ba(ve), w = R(P, 2), O = w[0], z = w[1], G = ar(null), V = R(G, 2), K = V[0], X = V[1], W = O(), N = ye(!1), F = ye(null);
  function Q() {
    return r();
  }
  var ue = ye(!1);
  function Ce() {
    z(ve), X(null, !0);
  }
  var ne = ir(function(J) {
    var Z = O();
    if (Z !== ve) {
      var se = Q();
      if (!(J && !J.deadline && J.target !== se)) {
        var Ge = ue.current, Ke;
        Z === Je && Ge ? Ke = g == null ? void 0 : g(se, J) : Z === et && Ge ? Ke = E == null ? void 0 : E(se, J) : Z === tt && Ge && (Ke = m == null ? void 0 : m(se, J)), Ge && Ke !== !1 && Ce();
      }
    }
  }), je = $a(ne), Te = R(je, 1), _e = Te[0], Ae = function(Z) {
    switch (Z) {
      case Je:
        return A(A(A({}, oe, f), we, h), Re, b);
      case et:
        return A(A(A({}, oe, p), we, v), Re, T);
      case tt:
        return A(A(A({}, oe, y), we, S), Re, x);
      default:
        return {};
    }
  }, le = M.useMemo(function() {
    return Ae(W);
  }, [W]), ke = Ga(W, !e, function(J) {
    if (J === oe) {
      var Z = le[oe];
      return Z ? Z(Q()) : io;
    }
    if (ee in le) {
      var se;
      X(((se = le[ee]) === null || se === void 0 ? void 0 : se.call(le, Q(), null)) || null);
    }
    return ee === Re && W !== ve && (_e(Q()), l > 0 && (clearTimeout(F.current), F.current = setTimeout(function() {
      ne({
        deadline: !0
      });
    }, l))), ee === Zn && Ce(), Ua;
  }), _ = R(ke, 2), De = _[0], ee = _[1], Ue = ao(ee);
  ue.current = Ue;
  var Er = ye(null);
  oo(function() {
    if (!(N.current && Er.current === t)) {
      H(t);
      var J = N.current;
      N.current = !0;
      var Z;
      !J && t && c && (Z = Je), J && t && i && (Z = et), (J && !t && u || !J && d && !t && u) && (Z = tt);
      var se = Ae(Z);
      Z && (e || se[oe]) ? (z(Z), De()) : z(ve), Er.current = t;
    }
  }, [t]), nt(function() {
    // Cancel appear
    (W === Je && !c || // Cancel enter
    W === et && !i || // Cancel leave
    W === tt && !u) && z(ve);
  }, [c, i, u]), nt(function() {
    return function() {
      N.current = !1, clearTimeout(F.current);
    };
  }, []);
  var Et = M.useRef(!1);
  nt(function() {
    B && (Et.current = !0), B !== void 0 && W === ve && ((Et.current || B) && (C == null || C(B)), Et.current = !0);
  }, [B, W]);
  var xt = K;
  return le[oe] && ee === we && (xt = k({
    transition: "none"
  }, xt)), [W, ee, xt, B ?? t];
}
function Ya(e) {
  var t = e;
  $(e) === "object" && (t = e.transitionSupport);
  function r(o, i) {
    return !!(o.motionName && t && i !== !1);
  }
  var n = /* @__PURE__ */ M.forwardRef(function(o, i) {
    var a = o.visible, c = a === void 0 ? !0 : a, s = o.removeOnLeave, u = s === void 0 ? !0 : s, l = o.forceRender, d = o.children, f = o.motionName, p = o.leavedClassName, y = o.eventProps, h = M.useContext(Qn), v = h.motion, S = r(o, v), b = ye(), T = ye();
    function x() {
      try {
        return b.current instanceof HTMLElement ? b.current : To(T.current);
      } catch {
        return null;
      }
    }
    var g = Ka(S, c, x, o), E = R(g, 4), m = E[0], C = E[1], I = E[2], L = E[3], B = M.useRef(L);
    L && (B.current = !0);
    var H = M.useCallback(function(V) {
      b.current = V, ln(i, V);
    }, [i]), P, w = k(k({}, y), {}, {
      visible: c
    });
    if (!d)
      P = null;
    else if (m === ve)
      L ? P = d(k({}, w), H) : !u && B.current && p ? P = d(k(k({}, w), {}, {
        className: p
      }), H) : l || !u && !p ? P = d(k(k({}, w), {}, {
        style: {
          display: "none"
        }
      }), H) : P = null;
    else {
      var O;
      C === oe ? O = "prepare" : ao(C) ? O = "active" : C === we && (O = "start");
      var z = on(f, "".concat(m, "-").concat(O));
      P = d(k(k({}, w), {}, {
        className: vo(on(f, m), A(A({}, z, z && O), f, typeof f == "string")),
        style: I
      }), H);
    }
    if (/* @__PURE__ */ M.isValidElement(P) && fn(P)) {
      var G = Ro(P);
      G || (P = /* @__PURE__ */ M.cloneElement(P, {
        ref: H
      }));
    }
    return /* @__PURE__ */ M.createElement(Da, {
      ref: T
    }, P);
  });
  return n.displayName = "CSSMotion", n;
}
const qa = Ya(no);
var cr = "add", ur = "keep", lr = "remove", Ot = "removed";
function Qa(e) {
  var t;
  return e && $(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, k(k({}, t), {}, {
    key: String(t.key)
  });
}
function fr() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(Qa);
}
function Za() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = [], n = 0, o = t.length, i = fr(e), a = fr(t);
  i.forEach(function(u) {
    for (var l = !1, d = n; d < o; d += 1) {
      var f = a[d];
      if (f.key === u.key) {
        n < d && (r = r.concat(a.slice(n, d).map(function(p) {
          return k(k({}, p), {}, {
            status: cr
          });
        })), n = d), r.push(k(k({}, f), {}, {
          status: ur
        })), n += 1, l = !0;
        break;
      }
    }
    l || r.push(k(k({}, u), {}, {
      status: lr
    }));
  }), n < o && (r = r.concat(a.slice(n).map(function(u) {
    return k(k({}, u), {}, {
      status: cr
    });
  })));
  var c = {};
  r.forEach(function(u) {
    var l = u.key;
    c[l] = (c[l] || 0) + 1;
  });
  var s = Object.keys(c).filter(function(u) {
    return c[u] > 1;
  });
  return s.forEach(function(u) {
    r = r.filter(function(l) {
      var d = l.key, f = l.status;
      return d !== u || f !== lr;
    }), r.forEach(function(l) {
      l.key === u && (l.status = ur);
    });
  }), r;
}
var Ja = ["component", "children", "onVisibleChanged", "onAllRemoved"], es = ["status"], ts = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function rs(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : qa, r = /* @__PURE__ */ function(n) {
    ht(i, n);
    var o = pt(i);
    function i() {
      var a;
      fe(this, i);
      for (var c = arguments.length, s = new Array(c), u = 0; u < c; u++)
        s[u] = arguments[u];
      return a = o.call.apply(o, [this].concat(s)), A(Se(a), "state", {
        keyEntities: []
      }), A(Se(a), "removeKey", function(l) {
        a.setState(function(d) {
          var f = d.keyEntities.map(function(p) {
            return p.key !== l ? p : k(k({}, p), {}, {
              status: Ot
            });
          });
          return {
            keyEntities: f
          };
        }, function() {
          var d = a.state.keyEntities, f = d.filter(function(p) {
            var y = p.status;
            return y !== Ot;
          }).length;
          f === 0 && a.props.onAllRemoved && a.props.onAllRemoved();
        });
      }), a;
    }
    return de(i, [{
      key: "render",
      value: function() {
        var c = this, s = this.state.keyEntities, u = this.props, l = u.component, d = u.children, f = u.onVisibleChanged;
        u.onAllRemoved;
        var p = Bt(u, Ja), y = l || M.Fragment, h = {};
        return ts.forEach(function(v) {
          h[v] = p[v], delete p[v];
        }), delete p.keys, /* @__PURE__ */ M.createElement(y, p, s.map(function(v, S) {
          var b = v.status, T = Bt(v, es), x = b === cr || b === ur;
          return /* @__PURE__ */ M.createElement(t, an({}, h, {
            key: T.key,
            visible: x,
            eventProps: T,
            onVisibleChanged: function(E) {
              f == null || f(E, {
                key: T.key
              }), E || c.removeKey(T.key);
            }
          }), function(g, E) {
            return d(k(k({}, g), {}, {
              index: S
            }), E);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(c, s) {
        var u = c.keys, l = s.keyEntities, d = fr(u), f = Za(l, d);
        return {
          keyEntities: f.filter(function(p) {
            var y = l.find(function(h) {
              var v = h.key;
              return p.key === v;
            });
            return !(y && y.status === Ot && p.status === lr);
          })
        };
      }
    }]), i;
  }(M.Component);
  return A(r, "defaultProps", {
    component: "div"
  }), r;
}
const Ss = rs(no);
export {
  q as $,
  ds as A,
  Ia as B,
  or as C,
  La as D,
  fs as E,
  lt as F,
  Po as G,
  dn as H,
  ht as I,
  pt as J,
  fn as K,
  Ro as L,
  ss as M,
  To as N,
  vr as O,
  ft as P,
  ge as Q,
  xe as R,
  Sn as S,
  ln as T,
  Tr as U,
  ls as V,
  Ho as W,
  Lo as X,
  vn as Y,
  Do as Z,
  k as _,
  de as a,
  Fr as a0,
  Ha as a1,
  la as a2,
  ko as a3,
  bs as a4,
  Vn as a5,
  yt as a6,
  Ko as a7,
  ua as a8,
  vt as a9,
  fa as aa,
  ps as ab,
  Kt as ac,
  Ss as ad,
  Co as ae,
  ys as af,
  Bo as ag,
  ms as ah,
  ra as ai,
  Ze as aj,
  mo as ak,
  Ht as al,
  Se as am,
  cs as an,
  Eo as ao,
  fe as b,
  A as c,
  R as d,
  Ur as e,
  ar as f,
  gs as g,
  ir as h,
  us as i,
  wa as j,
  Cn as k,
  Ra as l,
  Gn as m,
  vo as n,
  vs as o,
  hs as p,
  $ as q,
  So as r,
  $n as s,
  Ne as t,
  Nt as u,
  Bt as v,
  Xe as w,
  Jt as x,
  qa as y,
  wo as z
};
